import React from "react";

const About: React.FC = () => (
    <section className="about" id="about">
        <div className="section-number on-light">01</div>
        <div className="container">
            <div className="about-grid">
                <div className="about-text">
                    <span className="section-eyebrow">Who We Are</span>
                    <h2 className="section-title dark">
                        Your Trusted<br />IT Partner
                    </h2>
                    <div className="about-rule" />
                    <p>
                        Founded with a vision to deliver tailored IT services that drive
                        business success, Syslogics has become Israel's premier technology
                        partner for forward-thinking companies.
                    </p>
                    <p>
                        Our expert team specializes in cloud solutions, infrastructure
                        management, cybersecurity, and comprehensive support services across
                        diverse industries with personalized, scalable technology strategies.
                    </p>
                    <div className="about-highlight">
                        <div className="highlight-bar" />
                        <p>
                            Bilingual excellence — fluent in English and Hebrew, delivering
                            culturally-aware solutions for international and local clients alike.
                        </p>
                    </div>
                </div>

                <div className="about-visual">
                    <div className="about-badge">
                        <span className="badge-number">
                            20<sup>+</sup>
                        </span>
                        <span className="badge-label">
                            Years of<br />Excellence
                        </span>
                    </div>
                    <div className="about-stats-mini">
                        <div>
                            <span className="stat-mini-num">70%</span>
                            <span className="stat-mini-label">Avg. downtime<br />reduction</span>
                        </div>
                        <div>
                            <span className="stat-mini-num">100+</span>
                            <span className="stat-mini-label">Enterprise<br />clients served</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default About;
